export default __webpack_public_path__ + "static/media/Smart Heart Bird Food Budgies.7a859b62.png";